module.exports = __webpack_public_path__ + "img/usa.04dfb82.webp";